import { ReactElement } from 'react';
import { HeadTag } from 'shared/components';
import { Box } from '@mui/material';
import PageHeader from 'shared/components/PageHeader';
import NotificationCenter from './components/NotificationCenter';

const NotificationPage = (): ReactElement => (
  <Box>
    <HeadTag title="Notification" />
    <PageHeader
      title="Notification Center"
      description="View and manage your notifications."
    />
    <NotificationCenter />
  </Box>
);

export default NotificationPage;
